@import '../../style/focus-outline.scss';
@import '../../style/reset.scss';
@import '../com-nav/com-nav-focus.scss';

/* Default style and mobile behaviour */
:host {
    --wcs-com-nav-item-gap: var(--wcs-semantic-spacing-base);
    --wcs-com-nav-item-font-size: var(--wcs-semantic-font-size-label-1);
    --wcs-com-nav-item-arrow-icon-color: var(--wcs-semantic-color-foreground-action-neutral-default);
    --wcs-com-nav-item-arrow-icon-font-size: 0.6rem;
    --wcs-com-nav-item-arrow-icon-font-family: icons;
    --wcs-com-nav-item-arrow-icon-line-height: 1;

    --wcs-com-nav-item-focus-outline-color: var(--wcs-semantic-color-border-focus-base);

    position: relative;
    display: inline-flex;
    align-items: center;
    gap: var(--wcs-com-nav-item-gap);
    height: fit-content;
    padding: 0 8px;

    font: inherit;

    ::slotted(a) {
        /* Default */
        @include reset-anchor;

        display: flex;
        align-items: center;
    }

    /* Common behaviour between Large Screen and Small Screens */
    .arrow-icon {
        display: inline-block;
        font-family: icons;
        color: var(--wcs-com-nav-item-arrow-icon-color);
        font-size: var(--wcs-com-nav-item-arrow-icon-font-size);
        line-height: var(--wcs-com-nav-item-arrow-icon-line-height);
        box-sizing: border-box;
    }

    .arrow-container {
        display: unset;
    }

    /**For mobile*/
    ::slotted(a:focus-visible) {
        outline: none;
    }
}

:host(:focus-within) {
    @include com-nav-item-mobile-focus-outline(var(--wcs-com-nav-item-focus-outline-color));
}

/* Large screen, specific behaviour */
@media screen and (min-width: 576px) {
    :host {
        ::slotted(a) {
            display: flex;
            align-items: center;
            height: 100%;

            /* Reset for pc */
            padding-top: unset;
            padding-bottom: unset;
            padding-left: unset;
        }

        // Focus outline style is handling by com-nav, com-nav-submenu and com-nav-category in desktop mode
    }
}
